var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatientSummaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43206 26.2381H17.8059C19.0776 26.2381 20.112 25.2036 20.112 23.932V7.68694H14.7312C13.4595 7.68694 12.4251 6.65248 12.4251 5.38086V0H2.43206C1.16043 0 0.125977 1.03446 0.125977 2.30608V23.932C0.125977 25.2036 1.16043 26.2381 2.43206 26.2381ZM5.50684 10.813H14.7312C15.156 10.813 15.4999 11.1568 15.4999 11.5817C15.4999 12.0065 15.156 12.3504 14.7312 12.3504H5.50684C5.08195 12.3504 4.73814 12.0065 4.73814 11.5817C4.73814 11.1568 5.08195 10.813 5.50684 10.813ZM5.50684 13.8877H14.7312C15.156 13.8877 15.4999 14.2316 15.4999 14.6564C15.4999 15.0813 15.156 15.4251 14.7312 15.4251H5.50684C5.08195 15.4251 4.73814 15.0813 4.73814 14.6564C4.73814 14.2316 5.08195 13.8877 5.50684 13.8877ZM5.50684 16.9625H14.7312C15.156 16.9625 15.4999 17.3063 15.4999 17.7312C15.4999 18.1561 15.156 18.4999 14.7312 18.4999H5.50684C5.08195 18.4999 4.73814 18.1561 4.73814 17.7312C4.73814 17.3063 5.08195 16.9625 5.50684 16.9625ZM5.50684 20.0373H11.6564C12.0813 20.0373 12.4251 20.3811 12.4251 20.806C12.4251 21.2309 12.0813 21.5747 11.6564 21.5747H5.50684C5.08195 21.5747 4.73814 21.2309 4.73814 20.806C4.73814 20.3811 5.08195 20.0373 5.50684 20.0373Z",
    fill: "#120078"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7311 6.14935H19.6616L13.9624 0.450195V5.38065C13.9624 5.80477 14.307 6.14935 14.7311 6.14935Z",
    fill: "#120078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientSummaryIcon);
export default __webpack_public_path__ + "static/media/patientSummaryIcon.76736f9d493685c7991cb85c25d39582.svg";
export { ForwardRef as ReactComponent };